import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './MeetingStatisticsChart.css';

// react-chartjs-2
//   React向けグラフ表示ライブラリ
//   ツールチップを常に表示する場合には、プラグインを作成する必要がある。
//   Webページ： https://github.com/jerairrest/react-chartjs-2
//   ライセンス情報： MIT Licensed Copyright (c) 2017 Jeremy Ayerstƒ
import {Doughnut} from 'react-chartjs-2';
import { isNullOrUndefined } from 'util';

export default class MeetingStatisticsChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total_comment_time: 0,
    };
    this.name_list = [];
    this.data_list = [];
    this.color_list = [
      // カラー参照元 https://www.colordic.org/p/
      // 左から1,7,2,8,3,9,4,10,5,11,6,12の順に並び替え
      '#ffa3a3',
      '#a3ffff',
      '#ffa3d1',
      '#a3ffd1',
      '#ffa3ff',
      '#a3ffa3',
      '#d1a3ff',
      '#d1ffa3',
      '#a3a3ff',
      '#ffffa3',
      '#a3d1ff',
      '#ffd1a3',

      '#ffdbdb',
      '#dbffff',
      '#eddbff',
      '#edffdb',
      '#ffdbed',
      '#dbffed',
      '#dbdbff',
      '#ffffdb',
      '#ffdbff',
      '#dbffdb',
      '#dbedff',
    ];
  }
  componentDidMount() {
    this.processPayload();
  }

  processPayload() {
    let time = 0;
    this.name_list = [];
    this.data_list = [];

    this.props.data.forEach(item => {
      time += Number(item.comment_total_time);
      this.name_list.push(item.user_name);
      this.data_list.push(item.comment_total_time);
    });

    if (!isNullOrUndefined(this.props.colorList )) {
      this.color_list = this.props.colorList;
    }
    this.setState({total_comment_time: time});
  }

  getMeetingStatisticsChart() {
    if(this.props.monthly_display) {
      return null;
    }

    let chart_data = {
      labels: this.name_list,
      datasets: [{
        data: this.data_list,
        backgroundColor: this.color_list,
        hoverBackgroundColor: this.color_list,
      }]
    };

    var totalCommentTime = this.state.total_comment_time;
    if (totalCommentTime === 0) {
      totalCommentTime = 1;
      chart_data = {
        labels: ["No Data"],
        datasets: [{
          data: [1],
          backgroundColor: ["gray"],
          hoverBackgroundColor: ["gray"],
        }]
      }
    }
    
    return (
      <div className="chart">
        <Doughnut data={chart_data}
                  width={225}
                  height={225}
                  options={{
                    cutoutPercentage: 50,
                    animation: {
                      animateScale: true
                    },
                    title: {
                      display: false,
                      text: '発言時間の割合'
                    },
                    legend: {
                      display: false,
                      position: 'right'
                    },
                    tooltips: {
                      backgroundColor: "rgb(255,255,255)",
                      callbacks: {
                        labelTextColor: function (tooltipItem, data) {
                          return "#192D5A";
                        },
                        label: function (tooltipItem, data) {
                          let strTooltips = [];
                          strTooltips.push(data.labels[tooltipItem.index] + " : "
                            + Math.floor(data.datasets[0].data[tooltipItem.index] / totalCommentTime * 100) + "%");
                          if (data.labels[tooltipItem.index] !== "No Data") {
                            strTooltips.push("発言時間 : " + data.datasets[0].data[tooltipItem.index] + "分");
                          }
                          return strTooltips;
                        }
                      },
                      displayColors: false,
                    },
                  }}/>
      </div>
    );
  }

  render() {
    return (
      <div className="meeting-statistics-chart">
        <div className="inner-box">
          {this.getMeetingStatisticsChart()}
        </div>
      </div>
    );
  }
}

MeetingStatisticsChart.PropType = {
  data: PropTypes.object,
};
